<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2021-12-10 19:38:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2023-07-20 10:26:37
 * @FilePath: /WeMeet_admin_project/wemeet-admin/src/vab/components/VabFooter/index.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <footer class="vab-footer">
    Copyright
    <vab-icon icon="copyright-line" />
    {{ fullYear }} {{ title.customTitle }}
  </footer>
</template>

<script>
  import { defineComponent, reactive, toRefs, onMounted } from 'vue'
  import { title } from '@/config'

  export default defineComponent({
    name: 'VabFooter',
    setup() {
      const state = reactive({
        title: {
          tenantName: '',
        },
      })
      onMounted(() => {
        state.title = JSON.parse(localStorage.getItem('customInfo'))
      })
      return {
        ...toRefs(state),
        fullYear: new Date().getFullYear(),
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 55px;
    padding: 0 $base-padding 0 $base-padding;
    color: rgba(0, 0, 0, 0.45);
    background: var(--el-color-white);
    border-top: 1px dashed $base-border-color;

    i {
      margin: 0 5px;
    }
  }
</style>
